import React from "react";
import { Checkbox } from "antd";
import "./CheckBox.module.css";

const CheckBox = ({
    color = "var(--primary-color)",
    className = "",
    onClick = { onClick },
    children,
     isDisabled = false,
    style = {},
    ...rest
}) => {
    return (
        <Checkbox
            className={`custom-ant-checkbox ${className}`}
            disabled={isDisabled ? true : false}
                 style={{ ...style }}
            {...rest}
        >
            {children}
        </Checkbox>
    );
};

export default CheckBox;
